





























































import firebase from "firebase/app";
import "firebase/auth";
import { Component, Vue } from "vue-property-decorator";
import { domain } from "@/domain";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import { createRecaptchaVerifier } from "@/util/recaptcha";
import { normalizeSpanishPhone } from "@/util/phone";
import QuickSnack from "@/components/QuickSnack.vue";

@Component({
  components: { QuickSnack }
})
export default class TwoFactorAuthPanel extends Vue {
  snackbar = "";
  isLoading = "";

  mfaRecaptchaContainerId = "settings-mfa-recaptcha";
  mfaRecaptchaVerifier: firebase.auth.RecaptchaVerifier | null = null;
  enrolledPhoneFactor: firebase.auth.MultiFactorInfo | null = null;
  mfaEnrollStep: "idle" | "code" = "idle";
  phoneNumber = "";
  mfaVerificationId = "";
  mfaCode = "";

  get lang() {
    return this.$store.state.lang.data;
  }

  created() {
    this.enrolledPhoneFactor = domain.backend.getEnrolledPhoneFactor();
  }

  cmdNormalizePhone() {
    this.phoneNumber = normalizeSpanishPhone(this.phoneNumber);
  }

  // Discards the previous widget (if any) before rendering a new one - reusing the
  // same container without clearing throws "reCAPTCHA has already been rendered".
  getFreshRecaptchaVerifier(): firebase.auth.RecaptchaVerifier {
    this.mfaRecaptchaVerifier?.clear();
    this.mfaRecaptchaVerifier = createRecaptchaVerifier(this.mfaRecaptchaContainerId);
    return this.mfaRecaptchaVerifier;
  }

  async cmdSendMfaCode() {
    this.phoneNumber = normalizeSpanishPhone(this.phoneNumber);
    this.isLoading = "mfaSend";
    try {
      const verifier = this.getFreshRecaptchaVerifier();
      this.mfaVerificationId = await domain.backend.startPhoneEnrollment(this.phoneNumber, verifier);
      this.mfaEnrollStep = "code";
      this.snackbar = this.lang.mfaCodeSentLegend;
    } catch (err) {
      util.logError("Error enviando código MFA", err);
      if (uiUtil.isMfaUnverifiedEmailError(err)) {
        await this.redirectToVerifyEmail();
      } else {
        this.snackbar = uiUtil.toMfaErrorMsg(err, this.lang);
      }
    }
    this.isLoading = "";
  }

  // The email must be verified before enrolling MFA - send the reinforced-login code
  // and take the user to the same screen the normal login flow uses to complete it.
  async redirectToVerifyEmail() {
    this.cmdCancelMfaEnroll();
    try {
      await domain.backend.reinforceSend();
    } catch (err) {
      util.logError("Error enviando código de refuerzo", err);
    }
    this.$store.commit("setNeedsReinforced", true);
    // The AuthReinforce view has its own lifecycle - a local snackbar here would be
    // destroyed on navigation, so the notice is carried through the store instead.
    this.$store.commit("setReinforcedLoginNotice", this.lang.mfaUnverifiedEmail);
    uiUtil.routePush(this, "/authreinforce");
  }

  async cmdConfirmMfaEnroll() {
    this.isLoading = "mfaConfirm";
    try {
      await domain.backend.completePhoneEnrollment(this.mfaVerificationId, this.mfaCode, this.phoneNumber);
      this.cmdCancelMfaEnroll();
      this.enrolledPhoneFactor = domain.backend.getEnrolledPhoneFactor();
      this.snackbar = this.lang.profileUpdated;
    } catch (err) {
      util.logError("Error confirmando enrolamiento MFA", err);
      this.snackbar = uiUtil.toMfaErrorMsg(err, this.lang);
    }
    this.isLoading = "";
  }

  cmdCancelMfaEnroll() {
    this.phoneNumber = "";
    this.mfaVerificationId = "";
    this.mfaCode = "";
    this.mfaEnrollStep = "idle";
  }

  async cmdUnenrollMfa() {
    if (!this.enrolledPhoneFactor) {
      return;
    }
    this.isLoading = "mfaUnenroll";
    try {
      await domain.backend.unenrollPhoneFactor(this.enrolledPhoneFactor);
      this.enrolledPhoneFactor = null;
      this.snackbar = this.lang.profileUpdated;
    } catch (err) {
      util.logError("Error quitando MFA", err);
      this.snackbar = uiUtil.toMfaErrorMsg(err, this.lang);
    }
    this.isLoading = "";
  }
}
